export default {
	"exchange.GetTheVerificationCode": "獲取驗證碼",
	"exchange.Resend": "重新發送",
	"exchange.PleaseEnterYourPhoneNumber": "請輸入手機號",
	"exchange.PleaseEnterTheCorrectMobilePhoneNumber": "請輸入正確的手機號",
	"exchange.please": "請",
	"exchange.sResendAfterThat": "s之後再重新發送",
	"exchange.FailedToGetVerificationCode": "獲取驗證碼失敗",
	"exchange.TheVerificationCodeIsNotLegitimate": "驗證碼不合法",
	"exchange.TheVerificationCodeIsIncorrect": "驗證碼錯誤",
	"exchange.ThereAreNoRedeemableItemsForThisMobilePhoneNumber": "該手機號沒有可兌換的商品",
	"exchange.VerificationCode": "驗證碼",
	"exchange.RedeemNow": "立即兌換",
	"exchange.SelectRedeemProducts": "選擇兌換商品"
}